import { useCallback, useEffect, useState } from 'react';

export const scrollDirections = {
  UP: 'up',
  DOWN: 'down',
  IDLE: 'idle',
};

const useScrollDirection = () => {
  const [prevY, setPrevY] = useState();
  const [scrollDirection, setScrollDirection] = useState(scrollDirections.IDLE);

  const handleNavigation = useCallback(
    e => {
      const window = e.currentTarget;

      setScrollDirection(
        prevY > window.scrollY ? scrollDirections.UP : scrollDirections.DOWN
      );

      setPrevY(window.scrollY);
    },
    [prevY]
  );

  useEffect(() => {
    setPrevY(window.scrollY);

    window.addEventListener('scroll', handleNavigation);

    return () => {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);

  return scrollDirection;
};

export default useScrollDirection;
